import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {convertToAngles, getInnerRadius, tau} from './studioUtility';
import {resampleWave, WAVE_NUM_SAMPLES} from "../../../utils/audioUtility";
import * as d3 from 'd3';

const waveWidth = 16;
const waveMargin = 20;


@observer
class StudioPlayerTrackWave extends Component {

    convertAngleToWaveIndex(angle) {
        return Math.floor(WAVE_NUM_SAMPLES * angle / tau);
    }

    calculateWavePath() {
        const {split, tier, startAngle, endAngle, rotateAngle = 0, trackBeatCount, absBeatCount, wave} = this.props;

        const maxAngle = Math.min(tau, convertToAngles(trackBeatCount, absBeatCount));
        const maxLength = Math.floor(WAVE_NUM_SAMPLES * maxAngle / tau);
        let fixedWave = resampleWave(wave, maxLength);

        const sourceStart = convertToAngles(split.sourceStart || 0, absBeatCount);

        const newLength = this.convertAngleToWaveIndex(endAngle - startAngle);
        let startFrom = Math.max(0, this.convertAngleToWaveIndex(sourceStart));

        // console.log('sourceStart: ' + sourceStart + ', splitStart: ' + splitStart);
        // console.log('split: ' + JSON.stringify(split));

        fixedWave = fixedWave.slice(startFrom, startFrom + newLength);

        let points = [];
        for (let i = 0; i < fixedWave.length; i++) {
            const w = fixedWave[i];
            const y1 = -getInnerRadius(tier) - waveMargin - w * waveWidth;
            const theta = rotateAngle +  startAngle + (endAngle - startAngle) / fixedWave.length * i;
            const x1Rot = -Math.sin(theta) * y1;
            const y1Rot = Math.cos(theta) * y1;
            points.push([x1Rot, y1Rot]);
        }
        for (let i = fixedWave.length - 1; i >= 0; i--) {
            const w = -fixedWave[i];
            const y1 = -getInnerRadius(tier) - waveMargin - w * waveWidth;
            const theta = rotateAngle + startAngle + (endAngle - startAngle) / fixedWave.length * i;
            const x1Rot = -Math.sin(theta) * y1;
            const y1Rot = Math.cos(theta) * y1;

            points.push([x1Rot, y1Rot]);
        }

        // to remove d3, we can do this: https://medium.com/@francoisromain/smooth-a-svg-path-with-cubic-bezier-curves-e37b49d46c74
        const lineGenerator = d3.line().curve(d3.curveCardinal);

        return lineGenerator(points);

    }



    render() {
        return (
            <path d={this.calculateWavePath()} className={"studio-track-wave"}/>
        );
    }
}

StudioPlayerTrackWave.propTypes = {
    index: PropTypes.number,
    split: PropTypes.object.isRequired,
    tier: PropTypes.number.isRequired,
    startAngle: PropTypes.number.isRequired,
    endAngle: PropTypes.number.isRequired,
    rotateAngle: PropTypes.number.isRequired,
    trackBeatCount: PropTypes.number.isRequired,
    absBeatCount: PropTypes.number.isRequired
};

export default StudioPlayerTrackWave;
